module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjRkZGIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMTYuOTk5IiBoZWlnaHQ9IjE3IiB4PSItLjUiIHk9Ii0uNSIgZmlsbD0iIzVEQjM0OCIgZmlsbC1ydWxlPSJub256ZXJvIiByeD0iNCIvPgogICAgICAgIDxwYXRoIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNNSA3LjhsMi4xMzMgMi4xMzNMMTIuMDY2IDUiLz4KICAgIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yes-indicator.svg
// module id = 488
// module chunks = 0